import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const FeaturedSuccess = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [tx, setTx] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      navigate("/dashboard/featured");
      return;
    }
    let attempts = 0;
    const maxAttempts = 8;
    const interval = setInterval(async () => {
      attempts += 1;
      try {
        const res = await api.get(`/featured/status/${sessionId}`);
        setTx(res.data);
        if (res.data.payment_status === "paid") {
          setStatus("paid");
          clearInterval(interval);
        } else if (res.data.status === "expired") {
          setStatus("expired");
          clearInterval(interval);
        } else if (attempts >= maxAttempts) {
          setStatus("timeout");
          clearInterval(interval);
        }
      } catch (e) {
        if (attempts >= maxAttempts) {
          setStatus("error");
          clearInterval(interval);
        }
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [sessionId, navigate]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-20 text-center" data-testid="featured-success-page">
      {status === "polling" && (
        <>
          <Loader2 className="w-16 h-16 mx-auto animate-spin text-primary" />
          <h1 className="font-heading text-3xl font-black mt-6">Memverifikasi pembayaran...</h1>
          <p className="text-muted-foreground mt-2">Mohon tunggu sebentar.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-20 h-20 mx-auto text-green-600" />
          <h1 className="font-heading text-4xl font-black mt-6" data-testid="payment-success-title">Pembayaran Berhasil!</h1>
          <p className="text-muted-foreground mt-2">
            Restoranmu sekarang Featured 🎉. Visibilitas akan meningkat segera di hasil pencarian dan homepage.
          </p>
          {tx && (
            <div className="warm-card p-5 mt-8 text-left">
              <div className="flex justify-between text-sm py-1">
                <span className="text-muted-foreground">Total</span>
                <span className="font-heading font-black">Rp {tx.amount?.toLocaleString("id-ID")}</span>
              </div>
              <div className="flex justify-between text-sm py-1">
                <span className="text-muted-foreground">Status</span>
                <span className="font-bold text-green-600">PAID</span>
              </div>
              <div className="flex justify-between text-sm py-1">
                <span className="text-muted-foreground">Session</span>
                <span className="font-mono text-xs truncate max-w-[200px]">{sessionId}</span>
              </div>
            </div>
          )}
          <div className="flex gap-3 justify-center mt-8">
            <Button onClick={() => navigate("/dashboard/featured")} variant="outline" className="rounded-full" data-testid="back-to-featured">Lihat Featured</Button>
            <Button onClick={() => navigate("/")} className="rounded-full">Ke Homepage</Button>
          </div>
        </>
      )}
      {(status === "expired" || status === "timeout" || status === "error") && (
        <>
          <XCircle className="w-20 h-20 mx-auto text-destructive" />
          <h1 className="font-heading text-3xl font-black mt-6">Pembayaran tidak berhasil</h1>
          <p className="text-muted-foreground mt-2">
            {status === "expired" ? "Sesi pembayaran kadaluarsa." : "Status pembayaran tidak terkonfirmasi."} Silakan coba lagi.
          </p>
          <Button onClick={() => navigate("/dashboard/featured")} className="rounded-full mt-6" data-testid="retry-featured">Coba Lagi</Button>
        </>
      )}
    </div>
  );
};

export default FeaturedSuccess;
